import { em } from 'polished'

import CSSPlugin from 'gsapAlias/CSSPlugin'
import TimelineLite from 'gsapAlias/TimelineLite'
import TweenLite from 'gsapAlias/TweenLite'

// eslint-disable-next-line no-unused-vars
const plugins = [CSSPlugin]

export const timeline = ({ iconRef, numRef, textRef }) => {
  const tl = new TimelineLite()

  tl.add([
    TweenLite.to(iconRef.current, 1, { scale: 1, rotation: 0 }).delay(0.3),
    TweenLite.fromTo(
      numRef.current,
      1,
      { transform: `translateX(${em(-80)})` },
      { alpha: 1, transform: `translateX(${em(-100)})` },
    ).delay(1.6),
    TweenLite.to(iconRef.current, 1, {
      transform: `translateX(${em(120)})`,
    }).delay(1.3),
    TweenLite.to(textRef.current, 1, { alpha: 1 }).delay(1.9),
  ])

  return tl
}
